import { getFileTypeFromFilename } from '../util';

export type UseFileTypeProps = {
  fileType?: string | null;
  filename?: string | null;
};

export const useFileType = ({
  fileType: fileTypeProp,
  filename,
}: UseFileTypeProps) => {
  const fileType = fileTypeProp || getFileTypeFromFilename(filename);

  const isPdf = fileType === 'pdf';
  const isVector = fileType === 'dwg' || fileType === 'dxf';

  return { fileType, isPdf, isVector };
};
